import { render, staticRenderFns } from "./CeremonyEventDetails.vue?vue&type=template&id=636f7688&scoped=true"
import script from "./CeremonyEventDetails.vue?vue&type=script&lang=js"
export * from "./CeremonyEventDetails.vue?vue&type=script&lang=js"
import style0 from "./CeremonyEventDetails.vue?vue&type=style&index=0&id=636f7688&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Development/graduation/graduate-frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636f7688",
  null
  
)

export default component.exports